import { Middleware, RelayNetworkLayerRequest } from 'react-relay-network-modern';

export default function operationNameMiddleware(): Middleware {
  return next => req => {
    if (typeof req.fetchOpts.body === 'string') {
      const body = JSON.parse(req.fetchOpts.body);
      if (req instanceof RelayNetworkLayerRequest) {
        body.operationName = req.operation.name;
      }
      req.fetchOpts.body = JSON.stringify(body);
    }
    return next(req);
  };
}
